import "./style/styless.scss";
import { ListProps } from "./models/Models";
import { TableProvider } from "./utils/TableProvider";
import ListView from "./components/list/index";

/* * ListComponent is a generic component that renders a list view based on the provided props.
  * It uses the TableProvider to manage the state and context of the list.
  * The component supports various features such as filtering, sorting, searching, and pagination.
  * It can handle different collections and collection groups, and allows for custom mapping of data.
  * The component can also render child collections and subcollections, and supports custom actions.
  * It is designed to be flexible and reusable across different parts of the application.
  * @param {ListProps<T>} props - The properties for the ListComponent.
  * @returns {JSX.Element} - The rendered ListComponent.
  */
export default function ListComponent<T>({
  listName,
  collection,
  collectionGroup,
  tabs,
  mapper,
  columns: columnsData,
  selection,
  defaultFilters: filters,
  defaultSorting: sorting,
  useFilter,
  searching,
  extra,
  action,
  childCollection,
  children,
  childColumns, // array of child column [array[0] array[1]
  childIndex, //number
  subcollection, // array of string
  subSubcollection,
  pagination,
}: ListProps<T>) {
  return (
    <TableProvider<T>
      collection={collection}
      mapper={mapper}
      collectionGroup={collectionGroup}
      tabs={tabs}
      columns={columnsData}
      selection={selection}
      filters={filters}
      sorting={sorting}
      searching={searching}
      extra={extra}
      useFilter={useFilter}
      subcollection={subcollection}
      subSubcollection={subSubcollection}
      listName={listName}
      pagination={pagination}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <ListView<T>
          collection={collection}
          collectionGroup={collectionGroup}
          tabs={tabs}
          mapper={mapper}
          columns={columnsData}
          selection={selection}
          defaultFilters={filters}
          defaultSorting={sorting}
          useFilter={useFilter}
          searching={searching}
          extra={extra}
          action={action}
          childCollection={childCollection}
          pagination={pagination}
        />
      </div>
    </TableProvider>
  );
}
